// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3T5Lp","title":"ClientInsurance_title__1v9xn","itemText":"ClientInsurance_itemText__1PF0Y"};